import { MapContainer, TileLayer, Circle } from "react-leaflet";
import { forwardRef } from "react";
import "leaflet/dist/leaflet.css";
import IncidentMarkers from "./MapMarkers";
import MapController from "./MapController";
import UserMarker from "./UserMarker";

const MapComponent = forwardRef(
  (
    {
      center,
      position,
      setPosition,
      incidents,
      setIncidents,
      pendingIncidents,
      setPendingIncidents,
      interactive,
      radius,
    },
    ref,
  ) => {
    const initialCenter = center;
    const BOUNDS = [
      [44.7228, 17.1245],
      [44.8235, 17.26],
    ];

    return (
      <MapContainer
        center={initialCenter}
        zoom={14}
        style={{ height: "100%", width: "100%" }}
      >
        <TileLayer
          attribution="&copy; OpenStreetMap"
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <IncidentMarkers
          incidents={incidents}
          pendingIncidents={pendingIncidents}
          onStatusChange={(incidentId, status) => {
            setPendingIncidents((prev) =>
              prev.filter((i) => i.id !== incidentId),
            );

            if (status === "APPROVED") {
              const approved = pendingIncidents.find(
                (i) => i.id === incidentId,
              );
              setIncidents((prev) => [...prev, approved]);
            }
          }}
        />
        {interactive && <UserMarker position={position} />}
        {radius && (
          <Circle
            center={position}
            radius={radius}
            pathOptions={{ color: "blue", fillOpacity: 0.2 }}
          />
        )}
        <MapController
          position={position}
          setPosition={setPosition}
          forwardRef={ref}
          bounds={BOUNDS}
        />
      </MapContainer>
    );
  },
);

export default MapComponent;
